import styled from "@mui/material/styles/styled";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {css} from "@emotion/react";


export const sidepanelWidth = 275;


export const StyledDashboard = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;


  &.search > main {
    & > .MuiAppBar-root {
      & > .MuiToolbar-root {
        & > :not(.search-box) {
          display: none;
        }

        .cancel-search {
          display: inline-block;
        }
      }
    }
  }

  & > main {
    flex: 1;

    & > .MuiAppBar-root {

      img {
        vertical-align: bottom;
        height: 2.75em;
      }

      .cancel-search {
        display: none;
      }

    }
  }

  .MuiDrawer-root {
    display: none;
    width: ${sidepanelWidth}px;
    max-width: ${sidepanelWidth}px;
    transition: ${({theme}) => theme.transitions.create('max-width')};
    position: sticky;
    z-index: 1101;
    height: 100vh;
    top: 0;

    & > .MuiPaper-root {
      position: relative;
      width: 100%;
      border: 0;

      .MuiListItemIcon-root {
        justify-content: center;
        transition: ${({theme}) => theme.transitions.create(['min-width', 'font-size', 'margin'])};
      }

      .MuiListItemText-root {
        color: ${({theme}) => theme.palette.text.primary};
        transition: ${({theme}) => theme.transitions.create(['flex'])};
        overflow: hidden;
        white-space: nowrap;
      }

      .active {
        background-color: ${({theme}) => theme.palette.primary.main}14;
      }

      .collapse-button {
        .MuiBox-root {
          transition: ${({theme}) => theme.transitions.create(['flex'])};
        }

        svg {
          transition: ${({theme}) => theme.transitions.create(['transform'])};
        }
      }
    }
  }

  ${({theme}) => theme.breakpoints.up('md')} {
    .MuiDrawer-root {
      display: flex;
    }

    &.collapsed {
      .MuiDrawer-root {
        max-width: 70px;

        .MuiListItemIcon-root {
          margin: auto;
          min-width: 24px;

          &:not(.main) {
            font-size: 24px;
          }

          &.main {
            font-size: 18px;
          }
        }

        .MuiListItemText-root {
          //max-width: 0;
          flex: 0;
        }

        .collapse-button {
          .MuiBox-root {
            flex: 0 !important;
          }

          svg {
            transform-origin: center center;
            transform: rotate(180deg);
          }
        }
      }
    }

    & > main {
      & > .MuiAppBar-root {
        .toggle-button, .logo-image {
          display: none;
        }
      }
    }
  }
`

export const StyledSwipableDrawer = styled(SwipeableDrawer)`

  & > .MuiPaper-root {
    width: ${sidepanelWidth}px;
    display: flex;
    flex-direction: column;
  }

  ${({theme}) => theme.breakpoints.up('md')} {
    display: none;
  }

  .MuiListItemText-root {
    color: ${({theme}) => theme.palette.text.primary};
  }
`
